import { AxiosInstance } from "axios"
import api from "@/services/api"
import { Format } from "@/types/format"

class FormatApi {
	private get axios (): AxiosInstance {
		return api.getAxios()
	}

	public async formatGet (): Promise<Format[]> {
		return (await this.axios.get("/format")).data
	}

	public async formatSave (format: Format): Promise<Format> {
		return (await this.axios.post("/format", format)).data
	}

	public async formatDelete (formatId: string): Promise<boolean> {
		const result = await this.axios.delete<void>(`format/${formatId}`)
		return result.status === 200
	}

	public async downloadPdf (formatTitle: string, recordId: string, format: Format) {
		const { timeZone, locale } = Intl.DateTimeFormat().resolvedOptions()
		const request = {
			timeZone,
			locale,
			format
		}

		const result = (await this.axios.post(`/format/pdf/${recordId}`, request, {
			responseType: "blob"
		})).data

		const urlObject = window.URL || window
		const url = urlObject.createObjectURL(result)
		const el = document.createElement("a")
		const title = formatTitle ? formatTitle + ".pdf" : "download.pdf"
		el.setAttribute("href", url)
		el.setAttribute("download", title)
		el.click()
		urlObject.revokeObjectURL(url)
	}
}

const formatApi = new FormatApi()
export default formatApi
